"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeTracker = void 0;
class TimeTracker {
    constructor(processName) {
        this.processName = processName;
        this.start = new Date();
        console.log(`Start: ${this.processName}`);
    }
    end() {
        const end = new Date();
        const time = end.getTime() - this.start.getTime();
        if (time > 2000) {
            console.log(`%c${this.processName} took: ${time} ms`, 'background: #222; color: #bada55');
            return;
        }
        console.log(`${this.processName} took: ${time} ms`);
    }
}
exports.TimeTracker = TimeTracker;
//# sourceMappingURL=TimeTracker.js.map